import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Button } from 'reactstrap'
import { saveCompanyMapping, deleteCompanyMapping } from '../../actions/keeperReconActions'

const CompanyMappingModal = ({ isOpen, toggle, keeperEnterpriseId, keeperEnterpriseName }) => {
  const dispatch = useDispatch()
  const companyLabels = useSelector((state) => state.keeperRecon.companyLabels)
  const mappings = useSelector((state) => state.keeperRecon.mappings)
  const [selectedCompanyId, setSelectedCompanyId] = useState('')
  const [searchText, setSearchText] = useState('')

  const existingMapping = (mappings || []).find(
    (m) => m.keeperEnterpriseId === keeperEnterpriseId
  )
  const isMapped = existingMapping != null

  const mappedCompanyLabel = isMapped
    ? (companyLabels || []).find((c) => c.value === existingMapping.companyId)?.label
    : null

  const filteredLabels = (companyLabels || []).filter((c) =>
    c.label?.toLowerCase().includes(searchText.toLowerCase())
  )

  const handleSave = () => {
    if (!selectedCompanyId) return

    const selected = companyLabels.find((c) => c.value === selectedCompanyId)
    const companyType = selected?.label?.includes('(Essentials)') ? 'Essentials' : 'Managed'

    dispatch(saveCompanyMapping(keeperEnterpriseId, keeperEnterpriseName, selectedCompanyId, companyType))
    setSelectedCompanyId('')
    setSearchText('')
    toggle()
  }

  const handleDelete = () => {
    dispatch(deleteCompanyMapping(keeperEnterpriseId))
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle}>
        Map Keeper Company
      </ModalHeader>
      <ModalBody>
        <div className="mb-3 p-2 bg-light rounded">
          <small className="text-muted">Keeper Company</small>
          <div><strong>{keeperEnterpriseName}</strong></div>
        </div>

        {isMapped && (
          <div className="mb-3">
            <small className="text-muted">Currently mapped to</small>
            <div className="d-flex justify-content-between align-items-center border rounded p-2 mt-1">
              <div>
                <strong>{mappedCompanyLabel || existingMapping.companyId}</strong>
                <small className="text-muted ms-2">({existingMapping.companyType})</small>
              </div>
              <Button size="sm" color="outline-danger" onClick={handleDelete}>
                Remove
              </Button>
            </div>
          </div>
        )}

        <hr />
        <h6>{isMapped ? 'Change ConnectWise Company' : 'Map to ConnectWise Company'}</h6>
        <Input
          type="text"
          placeholder="Search ConnectWise companies..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="mb-2"
        />
        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
          {searchText.length === 0 ? (
            <p className="text-muted small">Start typing to search ConnectWise companies...</p>
          ) : filteredLabels.length === 0 ? (
            <p className="text-muted small">No ConnectWise companies match your search.</p>
          ) : (
            filteredLabels.slice(0, 20).map((company) => (
              <div
                key={company.value}
                className={`d-flex justify-content-between align-items-center border rounded p-2 mb-1 ${
                  selectedCompanyId === company.value ? 'border-primary bg-light' : ''
                }`}
                style={{ cursor: 'pointer' }}
                onClick={() => setSelectedCompanyId(company.value)}
              >
                <span>{company.label}</span>
                {selectedCompanyId === company.value && (
                  <small className="text-primary">Selected</small>
                )}
              </div>
            ))
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" disabled={!selectedCompanyId} onClick={handleSave}>
          Save Mapping
        </Button>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  )
}

export default CompanyMappingModal
